import InterestCalculatedOnBalanceType from "@/models/Products/InterestCalculatedOnBalanceType";
import InterestDaysInYear from "@/models/Products/InterestDaysInYear";
import InterestRateType from "@/models/Products/InterestRateType";
import InterestNonWorkingDays from "@/models/Shared/NonWorkingDays";
import PostingScheduleType from "@/models/Shared/PostingScheduleType";
import PeriodType from "@/models/Shared/PeriodType";
import Amount from "@/models/Shared/Amount";
import DayOfWeek from "@/models/Shared/DayOfWeek";
import Month from "@/models/Shared/Month";
import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";
import EntityIdentifier from "@/models/Shared/EntityIdentifier";

export default class DepositInterestSettings extends BaseProductSettings {
    enabled: boolean = true;
    interestBearingThreshold: Amount = new Amount();
    rateType: InterestRateType = InterestRateType.Fixed;
    rateValue: number = 0;
    cumulativeRateValue: number;
    rateSourceId: string;
    rateSourceIdentifier: EntityIdentifier;
    accruedPeriodType: PeriodType = PeriodType.Day;
    accruedPeriodValue: number = 1;
    accruedPeriodOnDayOfWeek: DayOfWeek;
    accruedPeriodOnDayOfMonth: number;
    accruedPeriodOnMonth: Month;
    calculatedOnBalanceType: InterestCalculatedOnBalanceType = InterestCalculatedOnBalanceType.EndOfDayBalance;
    postingScheduleType: PostingScheduleType = PostingScheduleType.AnniversaryFirstTransaction;
    postedPeriodType: PeriodType = PeriodType.Month;
    postedPeriodValue: number = 1;
    postedPeriodOnDayOfWeek: DayOfWeek;
    postedPeriodOnDayOfMonth: number = 1;
    postedPeriodOnMonth: Month;
    daysInYearType: InterestDaysInYear = InterestDaysInYear.Actual365;
    nonWorkingDaysType: InterestNonWorkingDays = InterestNonWorkingDays.NextWorkingDay;
}